import React, {useContext, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";
import {TextField} from "@mui/material";
import StyledSelect from "../../Component/StyledSelect";


function AddOrganizer(props) {
    const title = 'Dodaj Organizatora';
    const description = 'Tutaj możesz dodać organizatora odpowiedzialnego za wydarzenie.';

    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [organization, setOrganization] = useState({id: user.facilities[0]?.id, label: user.facilities[0]?.name});

    function _send() {
        const formData = {
            name: name,
            phone: phone,
            email: email,
            address: address,
        };
        fetch(`/api/organizer/${organization.id}`, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                props.dismiss();
            })
            .catch(err => { console.log(err) })
    }

    return (<StyledModal isOpen={props.isOpen} title={title} description={description} send={_send} dismiss={props.dismiss}>
                <StyledSelect
                    name='name'
                    label='Organizacja'
                    value={organization}
                    onChange={(e, v) => setOrganization(v)}
                    items={user.facilities}
                />
                <TextField
                    onChange={(e) => setName(e.target.value)}
                    label='Nazwa'
                    value={name}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    onChange={(e) => setPhone(e.target.value)}
                    label='Telefon do organizatora'
                    value={phone}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    onChange={(e) => setEmail(e.target.value)}
                    label='Email do organizatora'
                    value={email}
                    variant="outlined"
                    fullWidth
                />
                <TextField
                    onChange={(e) => setAddress(e.target.value)}
                    label='Adres organizatora'
                    value={address}
                    variant="outlined"
                    fullWidth
                />

        </StyledModal>);
}
export default AddOrganizer;